import { LitElement, html, css } from 'lit';
import QRCode from 'qrcode';

class DashboardAppQrCode extends LitElement {
  static get styles() {
    return css`
        :host {
            width: 100%;
            height: 100%;
            display: none; /* 初期状態では非表示 */
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            position: fixed;
            background: #00000094;
            z-index: 1000;
          }

          
        :host([visible]) {
            display: block; /* visible属性がtrueの時に表示 */
        }

        div {
          width: 100%;
          height: 100%;
        }

        #qrcode{
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          position: fixed;
        }

        .qrcode-content {
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          position: fixed;

          width: 200px;
          height: 200px;
          background: white;
          border-radius: 20px;
        }

        .qrcode-download-text {
          font-size: 14px;
          color: blue;
          text-decoration: underline;
          cursor: pointer;
        }

        
    `;
  }

  //プロパティ設定
  static get properties() {
    return {
      url: { type: String },
      visible: { type: Boolean },
    };
  }

  updated(changedProperties) {
    if (changedProperties.has('visible')) {
      this.visible ? this.setAttribute('visible', '') : this.removeAttribute('visible');
    }
  }

  constructor() {
    super();
    this.visible = false;
  }

  firstUpdated() {
    const fontAwasomeStyle = document.querySelector(
      "link[rel='stylesheet'][data-name='fontawesomev6']"
    );
    const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
    fontAwasomeStyleClone.removeAttribute('disabled');
    this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);
  }

  async downloadQR() {
    const canvas = this.shadowRoot.getElementById('qrcode');
    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = 'qrcode.png';
    link.click();
  }

  /**
   * 指定されたURLでQRコードモーダルを表示します。
   * @param {string} url - QRコードに変換するURL
   */
  async show(url) {
    if (!url) {
      console.error('URL is required to show QR code.');
      return;
    }
    this.url = url;
    this.visible = true;

    // visibleプロパティの変更がDOMに反映されるのを待つ
    await this.updateComplete;

    const canvas = this.shadowRoot.getElementById('qrcode');
    if (canvas) {
      const options = {
        errorCorrectionLevel: 'H',
        width: 150,
      };
      // 渡されたURLでQRコードを生成
      QRCode.toCanvas(canvas, this.url, options).catch(err => {
        console.error('Failed to generate QR code:', err);
      });
    }
  }

  hide() {
    this.visible = false;
    this.remove();
  }

  render() {
    return html`
          <div @click="${this.hide}">
            <div class="qrcode-content ${this.visible ? 'active' : ''}"">
              <canvas id="qrcode"></canvas>
              <a class="qrcode-download-text" @click="${this.downloadQR}">QRコードをダウンロード</a>
            </div>
          </div>
    `;
  }
}

customElements.define('dashboard-app-qrcode', DashboardAppQrCode);
